<template>
  <div class="basic-form">

    <div class="inline-input-group clearfix">
      <label class="inline-input__label" for="counsel-part">상담분야(택1)</label>
      
      <label class="sorting-box-checking" for="counselFieldContribute">
        <input type="radio" name="counselPart" id ="counselFieldContribute" v-model="application.field"  class="sorting-box-check-input" value="사회공헌" title="사회공헌 선택" /> 사회공헌
      </label>  
      <label class="sorting-box-checking" for="counselFieldRelation">
        <input type="radio" name="counselPart" id ="counselFieldRelation" v-model="application.field" class="sorting-box-check-input" value="사회적관계" title="사회적관계 선택" /> 사회적관계
      </label>
      <label class="sorting-box-checking" for="counselFielddWork">  
        <input type="radio" name="counselPart" id ="counselFieldWork"  v-model="application.field" class="sorting-box-check-input" value="일" title="일 선택" /> 일
      </label>  
      <label class="sorting-box-checking" for="counselFieldFinance">
        <input type="radio" name="counselPart" id ="counselFieldFinance" v-model="application.field" class="sorting-box-check-input" value="재무" title="재무 선택" /> 재무
      </label>  
      <label class="sorting-box-checking" for="counselFieldFamily">
        <input type="radio" name="counselPart" id ="counselFieldFamily" v-model="application.field" class="sorting-box-check-input" value="가족" title="가족 선택" /> 가족
      </label>  
      <label class="sorting-box-checking" for="counselFieldLeisure">
        <input type="radio" name="counselPart" id ="isLeisure" v-model="application.field" class="sorting-box-check-input" value="여가" title="여가 선택" /> 여가
      </label> 
      <label class="sorting-box-checking" for="counselFieldHealth">  
        <input type="radio" name="counselPart" id ="counselFieldHealth" v-model="application.field" class="sorting-box-check-input" value="건강" title="건강 선택" /> 건강
      </label>  
      <label class="sorting-box-checking-2" for="counselFieldEtc">  
        <input type="radio" name="counselPart" id ="counselFieldEtc" v-model="application.field" class="sorting-box-check-input" value="기타" title="기타 선택" /> 기타
        <input type="text" class="form-control" placeholder="기타" v-model="application.fieldEtc" :disabled="application.field !== '기타'" name="etcContext" class="" title="기타">
      </label>   
    </div>
    
    <div class="inline-input-group clearfix agree">
      <label class="inline-input__label" for="counsel-desc">희망상담내용</label>
      <textarea class="form-control" placeholder="희망상담내용" maxlength="1000" v-model="application.desc" rows="3" title="회망상담내용"></textarea>
    </div>  

    <div class="inline-input-group clearfix">
      <label class="inline-input__label" for="counsel-name">회원이름</label>
      <p class="progress__only-text" id="counsel-name">{{member.name}}</p>
    </div>
    
    <div class="inline-input-group clearfix">
      <label class="inline-input__label" for="counsel-org">상담기관</label>
      <select class="input__select" v-model="application.org" id="counsel-org" title="counsel-org 선택">
        <option value="">기관 선택</option>
        <option v-for="item in orgList" :value="item.code">{{item.name}}</option>
        <!-- <option value="kjc">광진50+센터</option> -->
      </select>
    </div>    
    
    <div class="inline-input-group clearfix">
      <label class="inline-input__label" for="request-time">희망상담일시</label>
      <div class="f-gutter-10">
        <div class="f-gutter-10__li grid-3">
          <datepicker v-model="date" :input-class="'input__text'" language="ko"
                      :format="'yyyy-MM-dd'" :disabled="state.disabled" placeholder="희망일선택" id="request-time"></datepicker>
        </div>
        <div class="f-gutter-10__li grid-3">
          <select class="input__select" v-model="application.startTime" title="희망시작시간">
            <option value="">희망시작시간</option>
            <!-- option v-for="n in 12" :value="getTimeValue(n)">{{n + 8}}:00</option -->
            <option v-for="n in 24" :value="getTimeValue(n, 'string')">{{getTimeValue(n, 'time')}}</option>
          </select>
        </div>
        <div class="f-gutter-10__li grid-3">
          <select class="input__select" v-model="application.endTime" title="희망종료시간">
            <option value="">희망종료시간</option>
            <option v-for="n in 24" :value="getTimeValue(n+1, 'string')">{{getTimeValue(n+1, 'time')}}</option>
          </select>
        </div>
      </div>
    </div>    
    
    
    <div class="inline-input-group clearfix">
      <label class="inline-input__label" for="counsel-worked">재직여부</label>
      <label class="sorting-box-checking" for="counselWorkedWork">
        <input type="radio" name="counselWorked" id ="counselWorkedWork" v-model="application.workType" class="sorting-box-check-input" value="재직" title="재직 선택" /> 재직
      </label>  
      <label class="sorting-box-checking" for="counselWorkedRetirement">
        <input type="radio" name="counselWorked" id ="counselWorkedRetirement" v-model="application.workType" class="sorting-box-check-input" value="퇴직" title="퇴직 선택" /> 퇴직
      </label>
      <label class="sorting-box-checking" for="counselWorkedNoWork">  
        <input type="radio" name="counselWorked" id ="counselWorkedNoWork" v-model="application.workType" class="sorting-box-check-input" value="재직해당사항없음" title="재직해당사항없음 선택" /> 재직해당사항없음  
      </label> 
      </br> 
      <label class="sorting-box-checking" for="counselWorkedSelfEmp">
        (<input type="radio" name="counselWorkedetc" id ="counselWorkedSelfEmp" v-model="application.workTypeEtc" :disabled="application.workType !== '재직해당사항없음'" class="sorting-box-check-input" value="자영업" title="자영업 선택" /> 자영업
      </label>  
      <label class="sorting-box-checking" for="counselWorkedFreelancer">
        <input type="radio" name="counselWorkedetc" id ="counselWorkedFreelancer" v-model="application.workTypeEtc" :disabled="application.workType !== '재직해당사항없음'" class="sorting-box-check-input" value="프리랜서" title="프리랜서 선택" /> 프리랜서
      </label>       
      <label class="sorting-box-checking" for="counselWorkedHousewife">
        <input type="radio" name="counselWorkedetc" id ="counselWorkedHousewife" v-model="application.workTypeEtc" :disabled="application.workType !== '재직해당사항없음'" class="sorting-box-check-input" value="전업주부" title="전업주부 선택" /> 전업주부
      </label>  
      <label class="sorting-box-checking" for="counselWorkedJobetc">
        <input type="radio" name="counselWorkedetc" id ="counselWorkedJobetc" v-model="application.workTypeEtc" :disabled="application.workType !== '재직해당사항없음'" class="sorting-box-check-input" value="기타" title="기타 ) 선택" /> 기타 )
      </label>        
    </div>  
    
    <div class="inline-input-group clearfix">
      <label class="inline-input__label" for="counsel-retireym">퇴직년월</label>
      <div class="f-gutter-10">
         <div class="f-gutter-10__li grid-3">
            <input type="number" ref="formationYear" class="form-control width-30 display-inline date-picker year" :disabled="application.workType !== '퇴직'" v-model="application.retireYear" placeholder="YY(년, 숫자만 입력)" title="퇴직연도"/>
         </div>
         <div class="f-gutter-10__li grid-3">   
            <input type="number" ref="formationMonth" class="form-control width-30 display-inline date-picker month" :disabled="application.workType !== '퇴직'" v-model="application.retireMonth" placeholder="MM(월, 숫자만 입력)" title="퇴직월"/>
         </div>
      </div>
    </div>       
     
    <div class="inline-input-group clearfix">
      <label class="inline-input__label" for="counsel-school">학력</label>
      <label class="sorting-box-checking" for="isHighshcool">
        <input type="radio" name="counselSchool" id ="isHighshcool" v-model="application.schoolClass" class="sorting-box-check-input" value="고졸이하" title="고졸이하 선택" /> 고졸이하
      </label>  
      <label class="sorting-box-checking" for="isCollege">
        <input type="radio" name="counselSchool" id ="isCollege" v-model="application.schoolClass" class="sorting-box-check-input" value="전문대졸" title="전문대졸 선택" /> 전문대졸
      </label>
      <label class="sorting-box-checking" for="isUniverity">  
        <input type="radio" name="counselSchool" id ="isUniverity" v-model="application.schoolClass" class="sorting-box-check-input" value="대졸" title="대졸 선택" /> 대졸
      </label>  
      <label class="sorting-box-checking" for="isGraduate">
        <input type="radio" name="counselSchool" id ="isGraduate" v-model="application.schoolClass" class="sorting-box-check-input" value="대학원이상" title="대학원이상 선택" /> 대학원이상
      </label>  
      <label class="sorting-box-checking" for="isEtcSchool">
        <input type="radio" name="counselSchool" id ="isEtcSchool" v-model="application.schoolClass" class="sorting-box-check-input" value="기타" title="기타 선택" /> 기타
      </label>             
    </div>      
    
    <div class="inline-input-group clearfix">
      <label class="inline-input__label" for="counsel-jobgroup">희망직업군<br>(재직자 포함,택1)</label>
      <label class="sorting-box-checking" for="counselJobgroupOfficer">
        <input type="radio" name="jobgroup" id ="counselJobgroupOfficer" v-model="application.jobgroup" class="sorting-box-check-input" value="공무원" title="공무원 선택" /> 공무원
      </label>  
      <label class="sorting-box-checking" for="counselJobgroupTeacher">
        <input type="radio" name="jobgroup" id ="counselJobgroupTeacher" v-model="application.jobgroup" class="sorting-box-check-input" value="교사" title="교사 선택" /> 교사
      </label>
      <label class="sorting-box-checking" for="counselJobgroupFine">  
        <input type="radio" name="jobgroup" id ="counselJobgroupFine" v-model="application.jobgroup" class="sorting-box-check-input" value="금융/보험" title="금융/보험 선택" /> 금융/보험
      </label>  
      <label class="sorting-box-checking" for="counselJobgroupSales">
        <input type="radio" name="jobgroup" id ="counselJobgroupSales" v-model="application.jobgroup" class="sorting-box-check-input" value="영업/판매" title="영업/판매 선택" /> 영업/판매
      </label>  
      <label class="sorting-box-checking" for="counselJobgroupManage">
        <input type="radio" name="jobgroup" id ="counselJobgroupManage" v-model="application.jobgroup" class="sorting-box-check-input" value="사무직" title="사무직 선택" /> 사무직
      </label>  
      <label class="sorting-box-checking" for="counselJobgroupArt">
        <input type="radio" name="jobgroup" id ="counselJobgroupArt" v-model="application.jobgroup" class="sorting-box-check-input" value="디자인/방송/예술" title="디자인/방송/예술 선택" /> 디자인/방송/예술
      </label> 
      <label class="sorting-box-checking" for="counselJobgroupMedicne">  
        <input type="radio" name="jobgroup" id ="counselJobgroupMedicne" v-model="application.jobgroup" class="sorting-box-check-input" value="의료/보건" title="의료/보건 선택" /> 의료/보건
      </label>  
      <label class="sorting-box-checking" for="counselJobgroupCare">  
        <input type="radio" name="jobgroup" id ="counselJobgroupCare" v-model="application.jobgroup" class="sorting-box-check-input" value="사회복지" title="사회복지 선택" /> 사회복지
      </label> 
      <label class="sorting-box-checking" for="counselJobgroupConst">  
        <input type="radio" name="jobgroup" id ="counselJobgroupConst" v-model="application.jobgroup" class="sorting-box-check-input" value="건설/산업/생산" title="건설/산업/생산 선택" /> 건설/산업/생산
      </label> 
      <label class="sorting-box-checking" for="counselJobgroupScien">  
        <input type="radio" name="jobgroup" id ="counselJobgroupScien" v-model="application.jobgroup" class="sorting-box-check-input" value="전문과학기술서비스" title="전문과학기술서비스 선택" /> 전문과학기술서비스
      </label>
      <label class="sorting-box-checking" for="counselJobgroupEdu">  
        <input type="radio" name="jobgroup" id ="counselJobgroupEdu" v-model="application.jobgroup" class="sorting-box-check-input" value="교육/연구" title="교육/연구 선택" /> 교육/연구
      </label> 
      <label class="sorting-box-checking" for="counselJobgroupHouse">  
        <input type="radio" name="jobgroup" id ="counselJobgroupHouse" v-model="application.jobgroup" class="sorting-box-check-input" value="전업주부" title="전업주부 선택" /> 전업주부
      </label>                          
      <label class="sorting-box-checking-2" for="counselJobgroupEtc">  
        <input type="radio" name="jobgroup" id ="counselJobgroupEtc" v-model="application.jobgroup" class="sorting-box-check-input" value="기타" title="기타 선택" /> 기타
        <input type="text" class="form-control" placeholder="기타" v-model="application.jobgroupEtc" :disabled="application.jobgroup !== '기타'"  name="introContext" class="" title="기타">
      </label>        
    </div>
    
    <div class="inline-input-group clearfix">
      <label class="inline-input__label" for="counsel-house">가구</label>
      
      <label class="sorting-box-checking" for="counselHouseAMan">
        <input type="radio" name="counselHouse" id ="counselHouseAMan" v-model="application.houseType" class="sorting-box-check-input" value="1인가구" title="1인가구 선택" /> 1인가구
      </label>  
      <label class="sorting-box-checking" for="counselHouseCouple">
        <input type="radio" name="counselHouse" id ="counselHouseCouple" v-model="application.houseType" class="sorting-box-check-input" value="부부중심가구" title="부부중심가구 선택" /> 부부중심가구
      </label>
      <label class="sorting-box-checking" for="counselHouseFamily">  
        <input type="radio" name="counselHouse" id ="counselHouseFamily" v-model="application.houseType" class="sorting-box-check-input" value="자녀(부모)동거" title="자녀(부모)동거 선택" /> 자녀(부모)동거
      </label>  
      <label class="sorting-box-checking" for="counselHouseSingleparent">
        <input type="radio" name="counselHouse" id ="counselHouseSingleparent" v-model="application.houseType" class="sorting-box-check-input" value="한부모가구" title="한부모가구 선택" /> 한부모가구
      </label>  
    </div>    

    <div class="inline-input-group clearfix">
      <label class="inline-input__label" for="counsel-care">해당사항</label>
      <label class="sorting-box-checking" for="counselCareDisabledpersion">
        <input type="radio" name="careType1" id ="counselCareDisabledpersion"  v-model="application.careType1" class="sorting-box-check-input" value="장애인" title="장애인 선택" /> 장애인
      </label>  
      <label class="sorting-box-checking" for="counselCareBasicPerson">
        <input type="radio" name="careType1" id ="counselCareBasicPerson"  v-model="application.careType1" class="sorting-box-check-input" value="기초수급대상자" title="기초수급대상자 선택" /> 기초수급대상자
      </label>
      <label class="sorting-box-checking" for="counselCareBasicPersonup">  
        <input type="radio" name="careType1" id ="counselCareBasicPersonup"  v-model="application.careType1" class="sorting-box-check-input" value="차상위" title="차상위 선택" /> 차상위
      </label>  
      <label class="sorting-box-checking" for="counselCareEtc">
        <input type="radio" name="careType1" id ="counselCareEtc" v-model="application.careType1" class="sorting-box-check-input" value="기타" title="기타 선택" /> 기타
      </label>  
      <label class="sorting-box-checking" for="counselCareNo">
        <input type="radio" name="careType1" id ="counselCareNo"  v-model="application.careType1" class="sorting-box-check-input" value="해당사항없음" title="해당사항없음 선택" /> 해당사항없음
      </label>       
    </div> 
    
    
    <div class="inline-input-group clearfix">
      <label class="inline-input__label" for="counsel-intro">신청경로(택1)</label>
      
      <label class="sorting-box-checking" for="counselIntroFellow">
        <input type="radio" name="counselIntro" id ="counselIntroFellow" v-model="application.pathIntro" class="sorting-box-check-input" value="지인소개" title="지인소개 선택" /> 지인소개
      </label>  
      <label class="sorting-box-checking" for="counselIntroInternet">
        <input type="radio" name="counselIntro" id ="counselIntroInternet" v-model="application.pathIntro" class="sorting-box-check-input" value="인터넷" title="인터넷 선택" /> 인터넷
      </label>
      <label class="sorting-box-checking" for="counselIntroSns">  
        <input type="radio" name="counselIntro" id ="counselIntroSns" v-model="application.pathIntro" class="sorting-box-check-input" value="SNS" title="SNS 선택" /> SNS
      </label>  
      <label class="sorting-box-checking" for="counselIntroPrbooks">
        <input type="radio" name="counselIntro" id ="counselIntroPrbooks" v-model="application.pathIntro" class="sorting-box-check-input" value="홍보책자" title="홍보책자 선택" /> 홍보책자
      </label>  
      <label class="sorting-box-checking" for="counselIntroRadio">
        <input type="radio" name="counselIntro" id ="counselIntroRadio" v-model="application.pathIntro" class="sorting-box-check-input" value="라디오/팟캐스트" title="라디오/팟캐스트 선택" /> 라디오/팟캐스트
      </label>  
      <label class="sorting-box-checking" for="counselIntroOutdoor">
        <input type="radio" name="counselIntro" id ="counselIntroOutdoor" v-model="application.pathIntro" class="sorting-box-check-input" value="옥외광고" title="옥외광고 선택" /> 옥외광고
      </label> 
      <label class="sorting-box-checking" for="counselIntroOrgintro">  
        <input type="radio" name="counselIntro" id ="counselIntroOrgintro" v-model="application.pathIntro" class="sorting-box-check-input" value="타기관 안내" title="타기관 안내 선택" /> 타기관 안내
      </label>  
      <label class="sorting-box-checking" for="counselIntro50plus">  
        <input type="radio" name="counselIntro" id ="counselIntro50plus" v-model="application.pathIntro" class="sorting-box-check-input" value="50+재단/캠퍼스/센터" title="50+재단/캠퍼스/센터 선택" /> 50+재단/캠퍼스/센터
      </label> 
      <label class="sorting-box-checking" for="counselIntroTv">  
        <input type="radio" name="counselIntro" id ="counselIntroTv" v-model="application.pathIntro" class="sorting-box-check-input" value="TV" title="TV 선택" /> TV
      </label> 
      <label class="sorting-box-checking" for="counselIntroPaper">  
        <input type="radio" name="counselIntro" id ="counselIntroPaper" v-model="application.pathIntro" class="sorting-box-check-input" value="신문" title="신문 선택" /> 신문
      </label>                   
      <label class="sorting-box-checking-2" for="counselIntroEtcEtc">  
        <input type="radio" name="counselIntro" id ="counselIntroEtcEtc" v-model="application.pathIntro" class="sorting-box-check-input" value="기타" title="기타 선택" /> 기타
        <input type="text" class="form-control" placeholder="기타" v-model="application.pahtIntroEtc" :disabled="application.pathIntro !== '기타'" name="introContext" class="" title="기타">
      </label>   
    </div>    

    <div class="inline-input-group clearfix">
      <label class="inline-input__label" for="counsel-visit">이용경험<br>(중복가능)</label>
      
      <label class="sorting-box-checking" for="counselVisitFirst">
        <input type="checkbox" id ="counselVisitFirst" v-model="application.extType1"  class="sorting-box-check-input" value="처음방문" title="처음방문 선택" /> 처음방문
      </label>  
      <label class="sorting-box-checking" for="counselVisitExprience">
        <input type="checkbox" id ="counselVisitExprience" v-model="application.extType2" class="sorting-box-check-input" value="상담경험" title="상담경험 선택" /> 상담경험
      </label>
      <label class="sorting-box-checking" for="counselVisitCommunity">  
        <input type="checkbox" id ="counselVisitCommunity" v-model="application.extType3" class="sorting-box-check-input" value="커뮤니티활동" title="커뮤니티활동 선택" /> 커뮤니티활동
      </label>  
      <label class="sorting-box-checking" for="counselVisitProgram">
        <input type="checkbox" id ="counselVisitProgram" v-model="application.extType4" class="sorting-box-check-input" value="교육프로그램참여" title="교육프로그램참여 선택" /> 교육프로그램참여
      </label>  
      <label class="sorting-box-checking" for="counselVisitContest">
        <input type="checkbox" id ="counselVisitContest" v-model="application.extType5" class="sorting-box-check-input" value="공모사업참여" title="공모사업참여 선택" /> 공모사업참여
      </label>  
      <label class="sorting-box-checking" for="counselVisitForum">
        <input type="checkbox" id ="counselVisitForum" v-model="application.extType6" class="sorting-box-check-input" value="포럼/축제등 행사참여" title="포럼/축제등 행사참여 선택" /> 포럼/축제등 행사참여
      </label> 
      <label class="sorting-box-checking-2" for="counselVisitEtcVisit">  
        <input type="checkbox" id ="counselVisitEtcVisit" v-model="application.extType7" class="sorting-box-check-input" value="기타" title="기타 선택" /> 기타
        <input type="text" class="form-control" placeholder="기타"  v-model="application.expTypeEtc" class="" title="기타">
      </label>   
    </div>   
    
    <div class="inline-input-group clearfix">
      <label class="inline-input__label" for="counsel-career">주요경력및<br> 자격사항</label>
      <textarea class="input__textarea" v-model.trim="application.carRer" id="counsel-career" title="counsel-career 입력"></textarea>
    </div>    
    
    <!-- <div class="inline-input-group clearfix">
      <label class="inline-input__label" for="counsel-field">상담분야</label>
      <select class="input__select" v-model="application.field" id="counsel-field" title="counsel-field 선택">
        <option value="">구분 선택</option>
        <option v-for="item in fieldList" :value="item">{{item}}</option>
      </select>
    </div> -->

    <div class="inline-input-group clearfix">
      <label class="sorting-box-check-lebel" for="rule">  
        ■ 개인정보 수집 ∙ 활동 동의
		상담 신청자를 대상으로 아래와 같이 개인정보를 수집하고자 합니다.<br>
		※ 개인정보 수집ㆍ활용  목적 : 50+상담 프로그램 관련 서비스 제공 및 사업관리<br>
		※ 수집ㆍ활용 개인정보 항목 : 이름, 성별, 생년월일, 휴대전화번호, 이메일 주소<br>
		※ 개인정보 보유 및 이용기간 : 개인정보 수집ㆍ활용에 대해 동의한 날로부터 5년 이내<br>
      </label> 
      <label class="sorting-box-check-lebel" for="rule">  
        ■ 상담정보 수집 ∙ 활동 동의
                상담 신청자를 대상으로 아래와 같이 개인정보를 수집하고자 합니다.<br>
                     ※ 상담 시 수집한 일부 정보는 더 나은 품질의 상담 서비스 제공을 위해 서울시 
          50플러스재단 내 관계업무 담당자에게 공유되어 분석용ㆍ연구용 데이터로 활용될 수 있습니다.<br>
                     ※ 상담정보 항목에서는 개인정보 및 상담내용, 비밀항목 등은 제외됩니다.
      </label>       
    </div>    

    <div class="inline-input-group clearfix">
      <label class="sorting-box-check-lebel" for="rule">  
                     ※ 귀하는 위와 같은 개인정보 및 상담 데이터 수집ㆍ활용에 동의하지 않으실 수 있으며, 이 경우 50+상담 진행은 불가합니다. <br>
      </label> 
      <label class="sorting-box-check-lebel" for="rule">
               본인은 위 내용을 확인하였으며, 모든 내용에    
      </label> <br>        

      <label class="sorting-box-check-lebel" for="agree" style="font-weight:bold;">  
        <input type="radio" name="agree" id ="agree" v-model="application.agree" class="sorting-box-check-input" value="true" title="동의함 선택" />동의 합니다.
      </label>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <label class="sorting-box-check-lebel" for="disagree" style="font-weight:bold;">
        <input type="radio" name="agree" id ="disagree" v-model="application.agree" class="sorting-box-check-input" value="false" title="동의하지 않음 선택" />동의하지 않습니다.
      </label> 
    </div>  

    <div class="inline-input-group clearfix">    
      <label class="sorting-box-check-lebel" for="registeryear">  
        {{ new Date().getFullYear() }}년
      </label>   
      <label class="sorting-box-check-lebel" for="registermonth">  
        {{ new Date().getMonth()+1 }}월
      </label>  
      <label class="sorting-box-check-lebel" for="registerdate">  
        {{ new Date().getDate() }}일
      </label>                                
    </div>    


    <!-- <div class="inline-input-group clearfix">
      <label class="inline-input__label" for="counsel-desc">상담내용2</label>
      <textarea class="input__textarea" v-model.trim="application.desc" id="counsel-desc" title="counsel-desc 입력"></textarea>
    </div> -->

    <div class="form-submit-gruop">
      <button type="button" class="form-submit__btn btn--blue-line" @click="apply">상담신청</button>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import Datepicker from 'vuejs-datepicker';

  export default {
    components: { Datepicker },
    name: 'counsel-form',
    props: ['member', 'orgList', 'fieldList'],
    data() {
      return {
        application: {
          field: '',
          fieldEtc: '',
          org: '',
          date: '',
          startTime: '',
          endTime: '',
          desc: '',
          careType1: '',
          extType1: false,
          extType2: false,
          extType3: false,
          extType4: false,
          extType5: false,
          extType6: false,
          extType7: false,
          expTypeEtc: '',
          houseType: '',
          workType: '',
          retireYear: '',
          retireMonth: '',
          schoolClass: '',
          pathIntro: '',
          pahtIntroEtc: '',
          clientId: '',
          carRer: '',
          jobgroup: '',
          jobgroupEtc: '',
          agree: '',
          workTypeEtc: '',
        },
        state: {
          disabled: {
            to: new Date(Date.now() - (24 * 60 * 60 * 1000)),
          },
        },
        date: null,
        progressing: false,
      };
    },
    methods: {
    //  getTimeValue(index) {
    //    const HH = index + 8;
    //    const mm = '00';
    //
    //    return `${HH < 10 ? '0' : ''}${HH}${mm}`;
    //  },
      getTimeValue(index, format) {
        const halfIndex = Math.ceil(index / 2);
        const time = halfIndex + 8;
        let min = '30';
        if (index % 2 !== 0) {
          min = '00';
        }
        return `${time < 10 ? '0' : ''}${time}${format === 'time' ? ':' : ''}${min}`;
      },
      apply() {
        if (this.progressing) return;
        if (!this.application.field) {
          alert('상담분야를 선택해 주세요.');
          return;
        }
        if (this.application.field === '기타') {
          if (!this.application.fieldEtc.length === 0) {
            alert('기타 내용을 입력해 주세요.');
            return;
          }
        }
        if (!this.application.org) {
          alert('상담기관을 선택해 주세요.');
          return;
        }
        if (!this.date || !this.application.startTime || !this.application.endTime ||
          this.application.startTime >= this.application.endTime) {
          alert('상담 일시를 확인해 주세요.');
          return;
        }
        if (this.application.desc.length === 0) {
          alert('상담내용을 입력해 주세요.');
          return;
        }
        if (this.application.desc.length > 1000) {
          alert('상담내용은 최대 1000자입니다.');
          return;
        }
        if (!this.application.careType1) {
          alert('해당사항을 선택해 주세요.');
          return;
        }
        if (this.application.expType7 === '기타') {
          if (!this.application.expTypeEtc.length === 0) {
            alert('기타 내용을 입력해 주세요.');
            return;
          }
        }
        if (this.application.workType === '퇴직') {
          if (!this.application.retireYear) {
            alert('퇴직년을 입력해 주세요.');
            return;
          }
          if (!this.application.retireMonth) {
            alert('퇴직월을 입력해 주세요.');
            return;
          }
          if (this.application.retireYear.length > 2) {
            alert('퇴직년을 2자리로 입력해주세요.');
            return;
          }
          if (this.application.retireMonth.length > 2) {
            alert('퇴직월을 2자리로 입력해주세요.');
            return;
          }
        } else {
          this.application.retireYear = '';
          this.application.retireMonth = '';
        }
        if (!this.application.workType) {
          alert('재직여부를 선택해 주세요.');
          return;
        }
        if (this.application.workType === '재직해당사항없음') {
          if (!this.application.workTypeEtc) {
            alert('재직해당사항 없음 항목을 선택해 주세요.');
            return;
          }
        }
        if (!this.application.schoolClass) {
          alert('학력을 선택해 주세요.');
          return;
        }
        if (!this.application.pathIntro) {
          alert('신청경로를 선택해 주세요.');
          return;
        }
        if (this.application.pathIntro === '기타') {
          if (!this.application.pahtIntroEtc.length === 0) {
            alert('기타 내용을 입력해주세요.');
            return;
          }
        }
        if (!this.application.jobgroup) {
          alert('주된 직업군을 선택해 주세요.');
          return;
        }
        if (this.application.agree !== 'true') {
          alert('위 내용에 동의하여 주시기 바랍니다.');
          return;
        }
        if (!this.application.houseType) {
          alert('가구를 선택해 주세요.');
          return;
        }
        if (!this.application.pathIntro) {
          alert('주된 경로를 선택해 주세요.');
          return;
        }

        this.progressing = true;
        this.application.date = this.date.toISOString().substr(2, 8).split('-').join('');
        this.application.clientId = this.member.loginid;
        console.log(this.member);
        axios.post('/api/counsels', this.application).then(() => {
          this.progressing = false;
          this.application.field = '';
          this.application.org = '';
          this.date = '';
          this.application.startTime = '';
          this.application.endTime = '';
          this.application.desc = '';
          this.application.clientId = '';
          alert('상담신청이 완료되었습니다.');
          
          // 회원/비회원에 따른 페이지 이동
          if (this.member && this.member.loginid) {
            // 회원인 경우 마이페이지로 이동
            location.href = '/mypage-counsel.do?status=APPLICATION';
          } else {
            // 비회원인 경우 메인페이지로 이동
            location.href = '/index.do';
          }
        }).catch((e) => {
          this.progressing = false;
          alert(e.response.data.msg);
        });
      },
    },
  };
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// CounselForm.vue?70378403